export interface Filter {
    filterType: FilterType;
    value: string;
    count: number;
}

export enum FilterType { 
    StoreName = 'storeName',
    FileType = 'fileType',
    DocumentType = 'documentType',
    EntityType = 'entityType',
    IsRead = 'isRead',
    CreatedAt = 'createdAt'
}